export { default } from './PartiuGpFaq';
